import InputText from "@/common/InputText";
import { Add, Minus, SearchNormal1 } from "iconsax-react";
import React, { useCallback, useState } from "react";
import CategoryItem from "./CategoryItem";
import { toast } from "react-toastify";
import PriceInput from "@/common/PriceInput";
import Button from "@/common/Button";
import { SearchFilterCollapseType } from "@/types/Search";

function SearchFilterCollapse({
  checkedItems,
  categoryMenuData,
  setCategoryMenuData,
  getCategoryForSearch,
  setCheckedItems,
  brandMenuData,
  checkedBrandItems,
  getBrandForSearch,
  setCheckedBrandItems,
  setBrandMenuData,
  minValue,
  maxValue,
  setMinValue,
  setMaxValue,
  MAX_VALUE,
  resetFilter,
  filterCount,
}: SearchFilterCollapseType) {
  const [activeCollapse, setActiveCollapse] = useState<number | null>(null);

  const handleSearchCategory = useCallback(
    async (e: React.ChangeEvent<HTMLInputElement>) => {
      try {
        const response = await getCategoryForSearch({
          text: e?.target?.value,
        });
        if (response?.isSuccess) {
          setCategoryMenuData(response?.data);
        } else {
          toast.error("خطا در انجام عملیات ");
        }
      } catch (err) {
        console.log("error from get category", err);
      }
    },
    [getCategoryForSearch, setCategoryMenuData]
  );
  const handleCheckboxChange = (id: string) => {
    setCheckedItems((prev: Record<string, boolean>) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const toggleCollapse = (index: number) => {
    setActiveCollapse((prevIndex) => (prevIndex === index ? null : index));
  };

  const handleCheckboxBrandChange = (id: string) => {
    setCheckedBrandItems((prev: Record<string, boolean>) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  const handleSearchBrand = useCallback(
    async (e: React.ChangeEvent<HTMLInputElement>) => {
      try {
        const response = await getBrandForSearch({
          text: e?.target?.value,
        });
        if (response?.isSuccess) {
          setBrandMenuData(response?.data);
        } else {
          toast.error("خطا در انجام عملیات ");
        }
      } catch (err) {
        console.log("error from get brand", err);
      }
    },
    [getBrandForSearch, setBrandMenuData]
  );
  return (
    <>
      <div className="flex flex-col gap-4 px-5 w-full mt-8">
        <div className="  bg-white rounded-lg">
          <div
            onClick={() => toggleCollapse(1)}
            className="flex justify-between items-center p-4 cursor-pointer"
          >
            <span>دسته‌بندی</span>
            {activeCollapse === 1 ? (
              <Minus size="20" color="#6b7280" />
            ) : (
              <Add size="20" color="#6b7280" />
            )}
          </div>
          {activeCollapse === 1 && (
            <div className="py-4 bg-white rounded-lg">
              <div className="bg-white w-full  rounded-3xl p-3">
                <InputText
                  type="search"
                  placeholder="جستجو"
                  className="h-10 search-input text-base  border-2 border-ws-gray-800 container-contact-input"
                  containerClass="w-full  "
                  badge={<SearchNormal1 color="#686868" size={18} />}
                  badgeTextClass="pr-0 border-r-0"
                  onChange={handleSearchCategory}
                />
                <div className="h-52 overflow-auto mt-3 cat-search">
                  {categoryMenuData?.length ? (
                    categoryMenuData?.map((category) => (
                      <CategoryItem
                        key={category.id}
                        category={category}
                        checkedItems={checkedItems}
                        handleCheckboxChange={handleCheckboxChange}
                      />
                    ))
                  ) : (
                    <div>دیتایی موجود نیست</div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="  bg-white rounded-lg">
          <div
            onClick={() => toggleCollapse(2)}
            className="flex justify-between items-center p-4 cursor-pointer"
          >
            <span>برند</span>
            {activeCollapse === 2 ? (
              <Minus size="20" color="#6b7280" />
            ) : (
              <Add size="20" color="#6b7280" />
            )}
          </div>
          {activeCollapse === 2 && (
            <div className="py-4 bg-white rounded-lg">
              <div className="bg-white w-full  rounded-3xl p-3">
                <InputText
                  type="search"
                  placeholder="جستجو"
                  className="h-10 search-input text-base  border-2 border-ws-gray-800 container-contact-input"
                  containerClass="w-full  "
                  badge={<SearchNormal1 color="#686868" size={18} />}
                  badgeTextClass="pr-0 border-r-0"
                  onChange={handleSearchBrand}
                />
                <div className="h-52 overflow-auto mt-3 cat-search">
                  {brandMenuData?.length ? (
                    brandMenuData?.map((brand) => (
                      <CategoryItem
                        key={brand.id}
                        category={brand}
                        checkedItems={checkedBrandItems}
                        handleCheckboxChange={handleCheckboxBrandChange}
                      />
                    ))
                  ) : (
                    <div>دیتایی موجود نیست</div>
                  )}
                </div>
              </div>{" "}
            </div>
          )}
        </div>
        <div className="  bg-white rounded-lg">
          <div
            onClick={() => toggleCollapse(3)}
            className="flex justify-between items-center p-4 cursor-pointer"
          >
            <span>قیمت</span>
            {activeCollapse === 3 ? (
              <Minus size="20" color="#6b7280" />
            ) : (
              <Add size="20" color="#6b7280" />
            )}
          </div>
          {activeCollapse === 3 && (
            <div className="py-4 rounded-lg">
              <div className="bg-white w-full rounded-xl p-3">
                <PriceInput
                  minValue={minValue}
                  maxValue={maxValue}
                  setMinValue={setMinValue}
                  setMaxValue={setMaxValue}
                  MAX_VALUE={MAX_VALUE}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="w-full flex justify-between items-center px-6">
        <Button className="text-ws-grayBlue-600 px-5 py-2 bg-ws-grayBlue-600 rounded-xl">
          <span className=" text-white num-vazir w-full text-lg rounded-lg text-center h-full ">
            {filterCount} کالا
          </span>
        </Button>
        <Button className="text-ws-grayBlue-600 px-5 py-2 bg-white rounded-xl">
          <span onClick={resetFilter} className="text-lg font-thin">
            {"پاک کردن فیلترها"}
          </span>
        </Button>
      </div>
    </>
  );
}

export default SearchFilterCollapse;
